import { Helmet } from "react-helmet-async";

/** Social metadata owned by React during SSR and client navigation. */
export function SeoSocial({ title, description, url, image = "https://tokamdarius.ca/imagePartage.png" }: { title: string; description: string; url: string; image?: string }) {
  return <Helmet>
    <meta property="og:type" content="website" />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:url" content={url} />
    <meta property="og:image" content={image} />
    <meta property="og:site_name" content="Tokam Darius" />
    <meta property="og:locale" content="fr_CA" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={image} />
  </Helmet>;
}
